// src/modules/wallet/WalletApi.ts
import apiClient from '@skygroup/shared/API/apiClient';
import endpoints from '@skygroup/shared/API/endpoints';
import { Wallet } from '@skygroup/shared/utils/DiamondWalletInterfaces';
import { message } from 'antd';

export async function fetchDiamondsWallet(
  modelId?: string | number
): Promise<Wallet> {
  const res = await apiClient.get(
    `${endpoints.WALLETS.GET_CASHBACK}/${modelId}`
  );

  if (res?.data?.status === 'error') {
    message.error(res?.data?.data?.message);
  }

  return res.data?.data ?? res.data;
}
